goog.provide("shadow.js.shim.module$src$svg$artwork$not_found_svg$default");
shadow.js.shim.module$src$svg$artwork$not_found_svg$default = shadow.js.shim.module$src$svg$artwork$not_found_svg.default;
